import logo from './logo.svg';
import React from 'react';
import './App.css';
import { BrowserRouter } from "react-router-dom";
import { AppContextProvider } from "./contexts/AppContext";
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { Routes } from './components/Routes';
import { GlobalStyles } from './styles/GlobalStyles';
import { PollingTimer } from './components/PollingTimer';
import { Auth } from 'aws-amplify';
import { Footer } from './components/dashboard/Footer';
import { ModalProvider } from 'styled-react-modal'
import { Settings } from './components/Settings';
import { DeliveryToggleConfirmation } from './components/dispatcher/DeliveryToggleConfirmation';
import {ModalController} from "./components/dispatcher/modals/ModalController";


const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'RobotoCondensed-Regular',
    ].join(','),
  },
});

const auth_config = {
  region: 'eu-west-2',
  identityPoolRegion: 'eu-west-2',
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  authenticationFlowType: 'USER_PASSWORD_AUTH',
}

Auth.configure(auth_config);

function App() {
  return (
    <AppContextProvider>
      <ThemeProvider theme={theme}>
        <ModalProvider>
          <BrowserRouter>
            <PollingTimer />
            <GlobalStyles />
            {/* <Navigation /> */}
            {/* <Header /> */}
            <Routes />
            <DeliveryToggleConfirmation />
            <ModalController/>
            <Settings />
            <Footer />
          </BrowserRouter>
        </ModalProvider>
      </ThemeProvider>
    </AppContextProvider>
  );
}

export default App;
